module.exports = __webpack_public_path__ + "img/筆記裝飾星星小.fefce321.svg";